import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark" | "system";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "system",
      setTheme: (theme) => set({ theme }),
    }),
    { name: "flowstack-theme" }
  )
);

export type ResolvedTheme = "light" | "dark";

export function resolveTheme(theme: Theme): ResolvedTheme {
  if (theme === "light" || theme === "dark") return theme;
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyThemeClass(theme: Theme): void {
  const resolved = resolveTheme(theme);
  // ``html.dark`` — what Tailwind's ``darkMode: "class"`` config keys
  // on (every ``dark:`` utility). Primary mechanism.
  document.documentElement.classList.toggle("dark", resolved === "dark");
  // ``html[data-theme]`` — mirrors orbit + pharmaforge's pattern so
  // the body ``background-image`` swap in globals.css and any
  // embedded ATTMOS-suite components can key on the attribute.
  document.documentElement.setAttribute("data-theme", resolved);
}
